import React from 'react';

export type DisclaimerContextType = {
  setCheckoutUrl: React.Dispatch<React.SetStateAction<string>>;
  checkoutUrl: string;
  // Slice-specific disclaimer methods
  setSliceDisclaimer: (sliceId: string, disclaimer: string) => void;
  getSliceDisclaimer: (sliceId: string) => string;
};

export const defaultDisclaimerContext: DisclaimerContextType = {
  setCheckoutUrl: () => {},
  checkoutUrl: '',
  setSliceDisclaimer: () => {},
  getSliceDisclaimer: () => '',
};

export const DisclaimerContext = React.createContext<DisclaimerContextType>(
  defaultDisclaimerContext,
);
